import React from 'react';
import { Heart, Users, Shield } from 'lucide-react';
import { mockData } from '../mock';

const Sponsors = () => {
  const { sponsors } = mockData;

  const getIcon = (iconName) => {
    const icons = {
      heart: <Heart size={36} strokeWidth={2.5} />,
      users: <Users size={36} strokeWidth={2.5} />,
      shield: <Shield size={36} strokeWidth={2.5} />
    };
    return icons[iconName];
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="patrocinadores" className="py-28 bg-[#fdfdfd] relative overflow-hidden">
      {/* Elementos decorativos de fundo */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-orange-100 rounded-full blur-[120px] opacity-50 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-100 rounded-full blur-[150px] opacity-40 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Título */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-black mb-6 text-[#0b1020] tracking-tight">
            Seja um <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-rose-600">Apoiador</span>
          </h2>
          <p className="text-xl text-gray-500 font-medium max-w-2xl mx-auto">
            Sua contribuição é o combustível para alcançarmos novos horizontes.
          </p>
        </div>

        {/* Cards de Benefícios */}
        <div className="grid md:grid-cols-3 gap-10 mb-24">
          {sponsors.benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="group relative bg-white rounded-[40px] p-10 transition-all duration-500 shadow-[0_20px_50px_rgba(0,0,0,0.05)] hover:shadow-[0_40px_80px_rgba(0,0,0,0.12)] hover:-translate-y-4 border border-gray-50 flex flex-col items-center text-center overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-white via-white to-orange-50/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="relative w-24 h-24 mb-8 rounded-3xl flex items-center justify-center text-white bg-gradient-to-br from-orange-500 to-rose-500 shadow-[0_15px_30px_rgba(249,115,22,0.3)] transform group-hover:rotate-[10deg] transition-transform duration-500">
                {getIcon(benefit.icon)}
                <div className="absolute inset-0 bg-white/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity" style={{ clipPath: 'polygon(0 0, 100% 0, 0 100%)' }} />
              </div>
              <h3 className="relative text-2xl font-bold text-gray-900 mb-4 group-hover:text-orange-600 transition-colors">
                {benefit.title}
              </h3>
              <p className="relative text-gray-500 leading-relaxed font-medium">
                {benefit.description}
              </p>
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gray-50 rounded-full group-hover:bg-orange-100 transition-colors duration-500" />
            </div>
          ))}
        </div>

        {/* Botão Falar Conosco */}
        <div className="text-center">
          <button
            onClick={() => scrollToSection('contato')}
            className="relative group inline-flex items-center justify-center"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-rose-600 rounded-2xl blur-xl opacity-40 group-hover:opacity-70 group-hover:scale-110 transition-all duration-500" />
            <div className="relative bg-[#0b1020] text-white font-bold px-12 py-6 rounded-2xl flex items-center gap-3 transform group-hover:scale-105 transition-all duration-300 shadow-2xl">
              <span className="text-lg">Falar Conosco Agora</span>
              <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-orange-500 transition-colors">
                →
              </div>
            </div>
          </button>
          <p className="mt-8 text-sm text-gray-400 font-bold uppercase tracking-[0.2em]">
            Invista no Futuro
          </p>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;